/*
    A ToolTip element that uses tippy.js

    props:
        target - A React component to use as the target for triggering the tooltip
            defaults to a .ui_help icon
        children - The content of the tooltip
        className - Classes to append to the wrapper of the target
        tag - HTML tag to use to wrap the target (useful until we can use Fragments from React 16)

    Some other props will be passed in the configuration object to tippy, see the getTippyOptions method

*/
import React from "react";
import classnames from "classnames";
import tippy from "tippy.js";
import pickBy from "lodash/pickBy";

class ToolTip extends React.Component {
    componentWillUnmount() {
        if (this.tippyEl && this.tippyEl._tippy) {
            this.tippyEl._tippy.destroy();
        }
    }
    componentDidMount() {
        if (this.tippyEl) {
            let options = this.getTippyOptions(this.props);
            if (this.contentEl) {
                // Tipp will actually move this element from inside React into
                // the actual tooltip. Weird but seems to work.
                options.html = this.contentEl;
            }
            tippy(this.tippyEl, options);
            // Just in case you want to default all tooltips to be visible
            // useful for dev
            // this.tippyEl._tippy.show();
        }
    }
    getTippyOptions(props) {
        let defaults = {
            interactive: true,
            interactiveBorder: 15,
            arrow: true,
            arrowTransform: "scaleX(1.5)",
            inertia: true,
            theme: "dark",
            placement: "bottom",
            delay: 300,
            distance: 16,
            trigger: "mouseenter focus",
            maxWidth: "250px"
        };

        let validOptions = Object.keys(defaults);

        // Only pass props that are in defaults to tippy
        let propOptions = pickBy(props, (v, k) => validOptions.includes(k));
        propOptions = {
            ...propOptions,
            onHide: this.onHide,
            onShow: this.onShow
        };
        return Object.assign(defaults, propOptions);
    }
    onHide = () => {
        if (this.props.onHide) {
            this.props.onHide();
        }
    };
    onShow = () => {
        if (this.props.onShow) {
            this.props.onShow();
        }
    };
    setToolTipRef = el => {
        this.tippyEl = el;
    };
    setContentRef = el => {
        this.contentEl = el;
    };
    render() {
        let content = this.props.children;

        let target = this.props.target || (
            <span className="hover-context">
                <i className="ui_help" />
            </span>
        );

        let targetClasses = classnames(
            "nounproject-tool-tip",
            this.props.className,
            { "default-tool-tip": !this.props.target }
        );

        let Tag = this.props.tag;

        return (
            <Tag className={targetClasses}>
                <Tag ref={this.setToolTipRef}>{target}</Tag>
                <Tag className="tippy-templates">
                    <Tag
                        className="tippy-content-wrapper"
                        ref={this.setContentRef}
                    >
                        {content}
                    </Tag>
                </Tag>
            </Tag>
        );
    }
}

ToolTip.defaultProps = {
    tag: "span"
};

export default ToolTip;
